import { LoadState } from "../../constants/enums";

export interface ICustomFormField {
  id: string | null;
  questionnaire_code: string | null;
  incremental_number: number | null;
  type: string;
  title: string;
  field_type: string;
  description: string;
  value: string;
  is_required: boolean;
  condition: string;
  show_description: string;
  attachments: string;
  fileUrl: string;
  options: { label: string; value: string }[];
  status: string;
}

export interface IDynamicFormTemplate {
  template_code: string;
  template_name: string;
  description: string;
  status: string;
  field_codes: string[];
  created_by_name?: string;
  modified_by_name?: string;
  create_ts?: string;
  insert_ts?: string;
}

export interface ITemplateField {
  questionnaire_id: number;
  incremental_number: number;
  questionnaire_code: string;
  type: string;
  title: string;
  field_type: string;
  description: string;
  show_description: string;
  is_required: number;
  condition: string;
  attachments: string;
  file_url: string | null;
  dynamics_forms: string | null;
  options: { label: string; value: string }[];
  status: string;
  created_by_id: number;
  created_by_name: string;
  modified_by_id: number;
  modified_by_name: string;
  create_ts: string;
  insert_ts: string;
  sort_order: number;
  value?: string;
  fileUrl?: string;
}

export interface ITemplateByCodeResponse {
  questionnaire_template_id: number;
  incremental_number: number;
  template_code: string;
  template_name: string;
  description: string;
  status: string;
  created_by_id: number;
  created_by_name: string;
  modified_by_id: number;
  modified_by_name: string;
  create_ts: string;
  insert_ts: string;
  fields: ITemplateField[];
}

export interface ICustomFormFieldsState {
  data: {
    list: ICustomFormField[];
    loading: LoadState;
  };
  templates: {
    list: IDynamicFormTemplate[];
    loading: LoadState;
  };
  allQuestionnaires: {
    list: ICustomFormField[];
    loading: LoadState;
  };
}

export const initialCustomFormFieldsState: ICustomFormFieldsState = {
  data: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  templates: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  allQuestionnaires: {
    list: [],
    loading: LoadState.NotLoaded,
  },
};
